import { render } from "./StartSection.vue?vue&type=template&id=2d4f5316"
import script from "./StartSection.vue?vue&type=script&lang=js"
export * from "./StartSection.vue?vue&type=script&lang=js"

import "./StartSection.vue?vue&type=style&index=0&id=2d4f5316&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__